import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { CREATE_MERCHANT } from './types';

export const createMerchant = createTaskAction(CREATE_MERCHANT);
